var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapSymbolPropertyDamaged = function SvgFiremapSymbolPropertyDamaged(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M8.286 16.5l1.195-1.2 1.7-.782-1.055-2.1 2.024-1.186-.81-1.734.975-.69L10.972 7.5 9.333 9.253v-.92h-.932v1.837l-1.378 1.51h1.263zm2 0 .637-.888 1.918-.746-.86-2.498 1.664-1-.803-1.891 1.123-.656 3.012 2.934H15.54V16.5z",
    clipRule: "evenodd"
  })));
};
export default SvgFiremapSymbolPropertyDamaged;